// extracted by mini-css-extract-plugin
export default {"paginateWrapper":"styles_paginateWrapper__hwznv","loader":"styles_loader__H38EN","container":"styles_container__Z7mcw","active":"styles_active__jPcis","count":"styles_count__+m6G+"};